import client from './client';

const getLocations = tenant =>
  client.get('/terrain/v1/evaluate/locations/', {
    params: {
      tenant_id: tenant
    }
  });

export default {
  getLocations
};
